import { render, staticRenderFns } from "./reservation-card.vue?vue&type=template&id=0bd9c443&scoped=true"
import script from "./reservation-card.vue?vue&type=script&lang=js"
export * from "./reservation-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd9c443",
  null
  
)

export default component.exports